import { useApi } from '@/config/apiFetcher'
import log from './useLogger'

export default async (encrypted: string) => {
  try {
    const api = useApi()
    const url = `${import.meta.env.VITE_CIPHER_ENDPOINT}/decrypt`
    const res = await api.post(url, {
      ciphertext: encrypted,
    })
    return res.data.text
  } catch (error) {
    log.error('error decrypting text', error)
    return null
  }
}

export const encrypt = async (text: string) => {
  try {
    const api = useApi()
    const url = `${import.meta.env.VITE_CIPHER_ENDPOINT}/encrypt`
    const res = await api.post(url, {
      text: text,
    })
    return res.data.ciphertext
  } catch (error) {
    log.error('error encrypting text', error)
    return null
  }
}
